import BaseListStore from 'stores/BaseListStore';
import WebhookErrorStore from 'stores/webook/WebhookErrorStore';
import { IDataFetchOptions } from '../../types';
import { buildOptions, getPage } from 'stores/_services/dataService';
import { action, makeObservable } from 'mobx';
import { getConditions, getListConditions } from 'stores/_services/filterService';
import { buildCsvDownloadUrl } from 'stores/_services/downloadService';

const SEARCH_FIELDS = ['errorName', 'errorMessage'];

export default class WebhookErrorListStore extends BaseListStore<WebhookErrorStore> {
    webhookId?: string;

    constructor(webhookId?: string) {
        super({
            itemStore: WebhookErrorStore,
            sortBy: 'createdOn'
        });

        makeObservable(this, {
            getWebhookErrors: action
        });

        this.webhookId = webhookId;
    }

    async getWebhookErrors(args: IDataFetchOptions = {}): Promise<void> {
        const shouldReset = this._updateListState(args);
        const conditions = getConditions(this.filter);
        conditions.push({ webhookId: this.webhookId });

        const options = {
            filter: {
                limit: this.limit,
                skip: this.skip,
                searchFields: SEARCH_FIELDS,
                order: this.sort,
                where: conditions
            }
        };

        const { data } = await getPage('webhookErrors', options);

        if (shouldReset) {
            this.clearIds();
        }

        this._updateData(data);
        this._updateIds(data, this.skip);
        this._updateCount(data);
    }

    public async exportToCsv(): Promise<void> {
        const conditions = getListConditions(this.selectedIdList, this.filter);
        conditions.push({ webhookId: this.webhookId });

        const options = {
            filter: {
                searchFields: SEARCH_FIELDS,
                where: conditions,
                order: this.sort
            }
        };

        const query = buildOptions(options);

        window.location.href = await buildCsvDownloadUrl('webhookErrors', query);
    }
}
